import { regex } from "../../constants/Regex";

const ConvertTimeFormat = (timeString) => {
  if (!timeString || timeString.trim() === "") {
    return "0:0";
  }

  // Check if the input string contains hours and minutes
  const matches = timeString.match(regex);

  if (matches) {
    // Extract hours and minutes from the matches
    const [, hoursString, minutesString] = matches;

    // Parse hours and minutes as integers
    const hours = parseInt(hoursString);
    const minutes = minutesString ? parseInt(minutesString) : 0;

    // Format the time as "HH:MM"
    const formattedTime = `${hours.toString().padStart(1, "0")}:${minutes
      .toString()
      .padStart(1, "0")}`;
    return formattedTime;
  } else {
    return "0:0";
  }
};

export default ConvertTimeFormat;
